import React, { useState } from "react";
import Categories from "./Categories";
import items from "./data";
import "./UI/FilterButton.css";
const allCategories = ["all", ...new Set(items.map((item) => item.category))];
const FilterButton = (props) => {
  const [menuItems, setMenuItems] = useState(items);
  const [activeCategory, setActiveCategory] = useState("");
  const [categories, setCategories] = useState(allCategories);
  const filterItems = (category) => {
    setActiveCategory(category);
    const newItems = items.filter((item) => item.category === category);
    setMenuItems(newItems);
  };
  return (
    <main>
      <section>
        <Categories
          categories={categories}
          activeCategory={activeCategory}
          filterItems={filterItems}
          buildingId={props.buildingId}
          year={props.year}
          getType={props.getType}
        />
      </section>
    </main>
  );
};
export default FilterButton;
